import SlickForScreenshots from "./SlickForSceenshots";

//slick slider for images slider wrapper
const Screenshots = ({data}) => {
    return(
      <>
        <section className="screenshots p-top-70">
            <div className="container">
                <SlickForScreenshots screenshotContent={data}  dataSettings={null}></SlickForScreenshots>
            </div>
        </section>
      </>
    );
}
  
export default Screenshots;